import { Pipe, PipeTransform } from '@angular/core';
import Constants from '../shared/constants';
import * as moment from 'moment';

@Pipe({ name: 'timeFormat' })
export class TimeFormatPipe implements PipeTransform {
    transform(value: string, args: string[]): any {
        if (!value) { return value; }
        return moment(value).format(Constants.TimeFormat);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/pipes/time-format.pipe.ts